import { render } from "./FiList.vue?vue&type=template&id=6d27c56c"
import script from "./FiList.vue?vue&type=script&lang=js"
export * from "./FiList.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__